import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex-1" }
const _hoisted_2 = ["for"]

import {computed, provide} from "vue";
import FieldError from "./FieldError.vue";
import FieldLabel from "./FieldLabel.vue";

interface Props {
  label: string;
  required?: boolean;
  error?: string|null;
  disabled?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'FieldGroup',
  props: {
    label: {},
    required: { type: Boolean },
    error: {},
    disabled: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const hasError = computed((): boolean => {
  if (props.disabled) {
    return false;
  }
  return !!props.error;
});

const fieldLabelId = Math.random().toString().substring(2);
provide('fieldLabelId', fieldLabelId);
provide('fieldHasError', hasError);
provide('fieldDisabled', computed(() => props.disabled));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", { for: _unref(fieldLabelId) }, [
      _createVNode(FieldLabel, {
        "has-error": hasError.value,
        title: props.label,
        required: props.required,
        disabled: props.disabled
      }, null, 8 /* PROPS */, ["has-error", "title", "required", "disabled"])
    ], 8 /* PROPS */, _hoisted_2),
    _renderSlot(_ctx.$slots, "default"),
    (hasError.value)
      ? (_openBlock(), _createBlock(FieldError, {
          key: 0,
          message: props.error!
        }, null, 8 /* PROPS */, ["message"]))
      : _createCommentVNode("v-if", true)
  ]))
}
}

})